import { PaginationState, SortingState } from '@tanstack/react-table';
import { EventAccordionItemBodyComponentType } from 'src/components/Accordions';
import { FormatOptionEntries } from 'src/modals/EditTableColumns';
import { PurchasesTableColumnId } from 'src/utils/columns/purchases/purchasesColumnUtils.types';
import {
  PurchaseOrderTicketGroup,
  PurchaseViewMode,
} from 'src/WebApiController';

export type PurchaseFormulaFields = {
  ticketCount?: number;
  unitCost?: number;
  totalCost?: number;
  totalPayment?: number;
};

import { TableProps } from '../Table/Table';

export const SHIMMERING_DIV_HEIGHT_SINGLE_PURCHASE = '30px';

export type PurchaseOrderTableDataProps = {
  useVirtuoso?: boolean;
} & Pick<
  EventAccordionItemBodyComponentType<PurchaseOrderTicketGroup>,
  | 'onMount'
  | 'onUnmount'
  | 'initState'
  | 'disablePagination'
  | 'onItemSelectionsChanged'
  | 'entities'
  | 'entityCount'
  | 'getDataFail'
  | 'enableColumnFilters'
>;

export type PurchaseOrderTableProps = PurchaseOrderTableDataProps & {
  groupId: string; // First of month, or event virtualId
  entitiesSummary?: PurchaseOrderTicketGroup | null;
  viewMode?: PurchaseViewMode;
  isSearchV2?: boolean;
  alwaysShowCheckbox?: boolean;
  showSelectAllOnHeader?: boolean;
  isItemsLoading?: boolean;
  rowSupportsAccordion?: boolean;
  columnVisibilityOverride?: PurchasesTableColumnId[];
  formatOptionOverrides?: FormatOptionEntries;
  withOuterPadding?: boolean;
  disableSelection?: boolean;
  isSideTable?: boolean;
  ignoreMaxCount?: boolean;
  onPaginationChange?: (pagination: PaginationState) => void;
  onSortingChange?: (sorting: SortingState) => void;
  /**
   * The current page index when using server-side pagination.
   */
  serverSidePageIndex?: number;
  /**
   * If true, pagination is controlled by the server.
   */
  manualPagination?: boolean;
  /**
   * The total row count when using server-side pagination.
   */
  rowCount?: number;
  /**
   * The page size when using server-side pagination.
   */
  pageSize?: number;
  totalCount?: number | null;
} & Pick<
    TableProps<PurchaseOrderTicketGroup | null>,
    'RowComponent' | 'virtuosoItemSize'
  >;
